export default __webpack_public_path__ + "static/media/productcatalogueapp.e0d073ff.png";